import { api } from './client';

export interface VendorAccess {
  can_access: boolean;
  can_manage_access: boolean;
}

export interface VendorAccessUser {
  id: string;
  name: string;
  email: string;
  role: 'admin' | 'member' | 'guest';
  has_access: boolean;
  can_manage_access: boolean;
}

export const vendorAccessApi = {
  getAccess: (signal?: AbortSignal) =>
    api.get<VendorAccess>('/vendor-access', undefined, { signal }),
  getUsers: () => api.get<{ users: VendorAccessUser[] }>('/vendor-access/users'),
  setAccess: (userId: string, hasAccess: boolean) =>
    api.patch<{ success: true }>(`/vendor-access/users/${encodeURIComponent(userId)}`, {
      has_access: hasAccess,
    }),
};
